import { Button } from 'finform';
import React, { Component } from 'react';
import { connect } from 'react-redux';
import { Link } from 'react-router-dom';
import {fromEvent, Subscription} from "rxjs";

import FormOnLogin from '#app/components/auth/FormOnLogin';
import { Row } from '#app/components/layout/styles';
import { Title2 } from '#app/components/texts/Typography';
import {HeaderProps, HeaderState} from "#app/interface/landing/header/types";
import {
  Modal,
  ModalClose,
  ModalContent,
  ModalFooter,
  ModalHeader,
} from '#app/interface/modal/Modal';
import Forgot from '#app/pages/Auth/Forgot';
import Register from '#app/pages/Auth/Register';
import {
  handleCloseModal,
  handleForgotModal,
  handleLoginModal,
  handleRegisterModal,
  login,
  logout,
} from '#app/store/actions/auth';
import {handleTitle} from "#app/store/actions/interface";

import {
  HeaderContainer,
  HeaderLogo,
  HeaderMenu,
  HeaderOther,
  HeaderOtherComment,
  HeaderOtherLink,
  HeaderPersonal,
  HeaderWrapper,
  ModalText,
  Wrap,
} from './styles';


class Header extends Component<HeaderProps, HeaderState> {
  private scrollSubscription: Subscription | null = null;

  constructor(props: HeaderProps) {
    super(props);
    this.state = {
      isScrolled: false,
      showFooter: true,
    };
    this.handleScroll = this.handleScroll.bind(this);
  }

  handleScroll() {
    if (window.pageYOffset > 0) {
      this.setState({ isScrolled: true });
    } else if (window.pageYOffset === 0) {
      this.setState({ isScrolled: false });
    }
  }

  componentDidMount() {
    this.scrollSubscription = fromEvent(document, 'scroll').subscribe(() => {
      this.handleScroll();
    });
  }

  componentWillUnmount() {
    this.scrollSubscription?.unsubscribe();
    this.scrollSubscription = null;
  }

  renderLoginModal() {
    return (
      <Modal
        size="extra-small"
        onClose={() => {
          Modal.handleClose();
          this.props.handleCloseModal();
        }}
        show={this.props.showLoginModal}
        trigger=""
      >
        <ModalHeader>
          <Title2 white>Вход</Title2>
          <ModalClose
            onClick={() => {
              Modal.handleClose();
              this.props.handleCloseModal();
            }}
          >
            <div />
          </ModalClose>
        </ModalHeader>
        <ModalContent>
          <FormOnLogin />
        </ModalContent>
        <ModalFooter>
          <Row>
            <ModalText>У вас нет аккаунта?</ModalText>
          </Row>
          <Row>
            <Button
              wide
              id="register-modal-button"
              onClick={() => {
                this.props.handleRegisterModal();
              }}
            >
              Регистрация
            </Button>
          </Row>
        </ModalFooter>
      </Modal>
    );
  }

  renderRegisterModal() {
    return (
      <Modal
        size="extra-small"
        onClose={() => {
          Modal.handleClose();
          this.props.handleCloseModal();
        }}
        show={this.props.showRegisterModal}
        trigger=""
      >
        <ModalHeader>
          <Title2 white>Регистрация</Title2>
          <ModalClose
            onClick={() => {
              Modal.handleClose();
              this.props.handleCloseModal();
            }}
          >
            <div />
          </ModalClose>
        </ModalHeader>
        <ModalContent>
          <Register
            handleTitle={this.props.handleTitle}
            handleCloseModal={this.props.handleCloseModal}
          />
        </ModalContent>
        {this.state.showFooter && (
          <ModalFooter>
            <Row>
              <ModalText>У вас есть аккаунт?</ModalText>
            </Row>
            <Button
              wide
              id="login-modal-button"
              onClick={() => {
                this.props.handleLoginModal();
              }}
            >
              Войти
            </Button>
          </ModalFooter>
        )}
      </Modal>
    );
  }

  renderForgotModal() {
    return (
      <Modal
        size="extra-small"
        onClose={() => {
          Modal.handleClose();
          this.props.handleCloseModal();
        }}
        show={this.props.showForgotModal}
        trigger={``}
      >
        <ModalHeader>
          <Title2 white>Забыли пароль</Title2>
          <ModalClose
            onClick={() => {
              Modal.handleClose();
              this.props.handleCloseModal();
            }}
          >
            <div />
          </ModalClose>
        </ModalHeader>
        <ModalContent>
          <Forgot
            callback={() => {
              Modal.handleShow();
              this.props.handleLoginModal();
            }}
            handleCloseModal={this.props.handleCloseModal}
          />
        </ModalContent>
        {this.state.showFooter && (
          <ModalFooter>
            <Button
              wide
              onClick={() => {
                Modal.handleClose();
                this.props.handleCloseModal();
              }}
            >
              Отмена
            </Button>
          </ModalFooter>
        )}
      </Modal>
    );
  }

  render() {
    return (
      <HeaderWrapper>
        <HeaderContainer className={this.state.isScrolled ? 'scrolled' : ''}>
          <Wrap>
            <HeaderLogo>
              <Link to="/">white swan</Link>
            </HeaderLogo>
            <HeaderMenu
              style={
                this.state.isScrolled
                  ? { transform: 'translate3d(0,-50%,0)', opacity: 1 }
                  : {}
              }
            />
          </Wrap>
          <HeaderPersonal>
            <Link
              to="/cabinet"
              id={"login-button"}
              onClick={(e) => {
                if (this.props.auth) return;
                e.preventDefault();
                Modal.handleShow();
                this.props.handleLoginModal();
              }}
            >
              Войти
            </Link>
          </HeaderPersonal>
          <HeaderOther>
            <a href="https://whiteswan.finance">
              <HeaderOtherLink />
              <HeaderOtherComment
                style={this.state.isScrolled ? { display: 'none' } : {}}
              >
                Приложение для финансового учёта
              </HeaderOtherComment>
            </a>
          </HeaderOther>
        </HeaderContainer>
        {this.renderLoginModal()}
        {this.renderRegisterModal()}
        {this.renderForgotModal()}
      </HeaderWrapper>
    );
  }
}

const enhance = connect(
  (state: {
    auth: {
      auth?: boolean;
      data?: any;
      showLoginModal?: boolean;
      showRegisterModal?: boolean;
      showForgotModal?: boolean;
    };
  }) => ({
    auth: state.auth.auth,
    data: state.auth.data,
    showLoginModal: state.auth.showLoginModal,
    showRegisterModal: state.auth.showRegisterModal,
    showForgotModal: state.auth.showForgotModal,
  }),
  {
    logout,
    handleLoginModal,
    handleCloseModal,
    handleRegisterModal,
    handleForgotModal,
    login,
    handleTitle,
  }
);

export default enhance(Header);
